import React, { useState } from "react";
import { Link } from "react-router-dom";
import Topbar from "./Topbar";
import { MdMenuOpen } from "react-icons/md";
// import { RiArrowDropDownLine } from "react-icons/ri";

const Header = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleNavbar = () => {
    setIsCollapsed((prev) => !prev);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  return (
    <>
      <Topbar />
      <div className="container-fluid nav-bar sticky-top px-0 px-lg-4 py-2 py-lg-0">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link to="/" className="">
              <img
                src="img/steward-logo.png"
                className="img-fluid"
                alt="logo 1"
                style={{ position: "absolute", width: "150px", top: "-1px" }}
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              onClick={toggleNavbar}
              aria-expanded={!isCollapsed}
            >
              <MdMenuOpen />
            </button>
            <div
              className={`collapse navbar-collapse ${
                !isCollapsed ? "show" : ""
              }`}
              id="navbarCollapse"
            >
              <div className="navbar-nav mx-auto py-0">
                <Link to="/" className="nav-item nav-link active">
                  Home
                </Link>
                <Link to="/about" className="nav-item nav-link">
                  About
                </Link>
                <Link to="/services" className="nav-item nav-link">
                  Service
                </Link>
                <Link to="/cars" className="nav-item nav-link">
                  Our Cars
                </Link>
                <div className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle"
                    onClick={toggleDropdown}
                    aria-expanded={isDropdownOpen}
                  >
                    Pages
                    {/* <RiArrowDropDownLine /> */}
                  </Link>
                  <div
                    className={`dropdown-menu m-0 ${
                      isDropdownOpen ? "show" : ""
                    }`}
                  >
                    <Link to="/features" className="dropdown-item">
                      Our Feature
                    </Link>
                    <Link to="/cars" className="dropdown-item">
                      Our Cars
                    </Link>
                    <Link to="/bookings" className="dropdown-item">
                      Book a Car
                    </Link>
                  </div>
                </div>
                <Link to="/contact" className="nav-item nav-link">
                  Contact
                </Link>
              </div>
              <Link
                to="/bookings"
                className="btn btn-primary rounded-pill py-2 px-4"
              >
                Book a Car
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
